document.addEventListener('DOMContentLoaded', function() {

    // =========================================================================
    // 1. LÓGICA DE PRECIOS VISUALES (Protección 5 Años)
    // =========================================================================

    function updateProtectionLabel() {
        // 1. Ver qué Chiller está seleccionado
        const chillerFieldset = document.querySelector('.custom_choose');
        if (!chillerFieldset) return;

        const selectedChiller = chillerFieldset.querySelector('input:checked');
        const chillerName = selectedChiller ? selectedChiller.value.trim() : '';

        // 2. Determinar el precio extra
        let price = 99; // Precio base (1/3HP o ninguno)

        if (chillerName.includes("1/2HP")) {
            price = 149;
        } else if (chillerName.includes("1HP") || chillerName.includes("PRO+")) {
            price = 199;
        }

        // 3. Encontrar el label de "5-Year"
        const protectionFieldset = document.querySelector('.custom_chooseprotection');
        if (!protectionFieldset) return;

        const fiveYearInput = protectionFieldset.querySelector('input[value="5-Year"]');
        if (!fiveYearInput) return;

        const label = protectionFieldset.querySelector(`label[for="${fiveYearInput.id}"]`);
        if (!label) return;

        const textElement = label.querySelector('.variant-name');

        // 4. ACTUALIZAR SOLO SI ES NECESARIO (Evita bucles infinitos)
        if (textElement) {
            const newText = `5-Year +$${price}`;
            // Solo tocamos el DOM si el texto es diferente al que queremos
            if (textElement.textContent.trim() !== newText) {
                textElement.textContent = newText;
            }
        }
    }

    // =========================================================================
    // 2. LÓGICA DEL SWITCH WIFI (Sincronización Visual)
    // =========================================================================

    function syncSwitchVisuals() {
        const wifiFieldset = document.querySelector('.wifi-option');
        if (!wifiFieldset) return;

        const wifiInput = wifiFieldset.querySelector('input[value^="Yes WiFi"], input[value^="Yes App Controlled"]');
        const switchContainer = wifiFieldset.querySelector('.switch-container');
        const switchButton = wifiFieldset.querySelector('#my-switch');

        if (!wifiInput || !switchContainer) return;

        const isWifiOn = wifiInput.checked;

        if (isWifiOn) {
            if (!switchContainer.classList.contains('is-active')) {
                switchContainer.classList.add('is-active');
                if (switchButton) switchButton.setAttribute('aria-checked', 'true');
            }
        } else {
            if (switchContainer.classList.contains('is-active')) {
                switchContainer.classList.remove('is-active');
                if (switchButton) switchButton.setAttribute('aria-checked', 'false');
            }
        }
    }

    // =========================================================================
    // 3. EL VIGILANTE (MUTATION OBSERVER) - LA SOLUCIÓN AL PROBLEMA
    // =========================================================================
    // Este código observa si Shopify borra tu texto y lo vuelve a poner

    const containerObserver = new MutationObserver((mutations) => {
        // Si Shopify cambia algo en el formulario, volvemos a ejecutar nuestras funciones
        // Gracias a los chequeos internos ("if text !== newText"), esto no crea un bucle.
        updateProtectionLabel();
        syncSwitchVisuals();
    });

    // Observamos el contenedor principal del producto para detectar recargas AJAX
    const productContainer = document.querySelector('.product__info-container') || document.querySelector('variant-selects');

    if (productContainer) {
        containerObserver.observe(productContainer, {
            childList: true, // Detectar si agregan/quitan elementos (recarga AJAX)
            subtree: true,   // Detectar cambios profundos
            characterData: true // Detectar cambios de texto
        });
    }

    // =========================================================================
    // 4. MANEJADORES DE EVENTOS
    // =========================================================================

    // A. Clic en el Switch de WiFi
    document.addEventListener('click', function(event) {
        const switchContainer = event.target.closest('.switch-container');
        if (!switchContainer) return;

        event.preventDefault();
        event.stopPropagation();

        const fieldset = switchContainer.closest('fieldset');
        if (!fieldset) return;

        const inputYes = fieldset.querySelector('input[value^="Yes WiFi"], input[value^="Yes App Controlled"]');
        const inputNo = fieldset.querySelector('input[value^="No WiFi"], input[value^="No App Controlled"]');

        if (inputYes && inputYes.checked) {
            if(inputNo) inputNo.click();
        } else if (inputYes) {
            inputYes.click();
        }
    });

    // B. Detectar cambios manuales
    document.addEventListener('change', function(event) {
        // Ejecutamos inmediatamente al detectar cambio
        if (event.target.closest('.custom_choose') || event.target.closest('.wifi-option')) {
            // Pequeño delay para asegurar que los inputs se actualizaron
            setTimeout(() => {
                updateProtectionLabel();
                syncSwitchVisuals();
            }, 10);
        }
    });

    // =========================================================================
    // 5. INICIALIZACIÓN
    // =========================================================================

    function init() {
        syncSwitchVisuals();
        updateProtectionLabel();
    }

    init(); // Al cargar

    // Respaldo estándar de Shopify por si el Observer falla
    document.addEventListener('shopify:section:load', init);
});
